export default __webpack_public_path__ + "static/media/55.3fba6e56.svg";